import { IPagination } from "../IPagination";

export enum AffiliateStatusEnum {
  Pending = 0,
  Approved = 1,
  Rejected = 2,
  Suspended = 3
}

export enum PayoutStatusEnum {
  Pending = 0,
  Approved = 1,
  Rejected = 3
}

export interface IAffiliate {
  id: number;
  affiliateName: string;
  email: string;
  promoCode: string;
  status: number;
  esimDiscountPercentage: number;
  busTicketDiscountPercentage: number;
  esimCommissionPercentage: number;
  busTicketCommissionPercentage: number;
  allowMultipleUses: boolean;
  expirationDate: string;
  phoneNumber: string;
  website: string;
  socialMediaUrl: string;
  applicationNote: string;
  adminNote: string;
  bankName: string;
  iban: string;
  accountHolderName: string;
  approvedDate: string;
  isActive: boolean;
  totalEarnings: number;
  totalReservations: number;
  insertDate: string;
}

export type IAffiliates = IPagination<IAffiliate>;

export interface IPayoutRequest {
  id: number;
  affiliateId: number;
  affiliateName: string;
  affiliateEmail: string;
  requestedAmount: number;
  approvedAmount: number;
  status: number;
  bankName: string;
  iban: string;
  accountHolderName: string;
  note: string;
  adminNote: string;
  processedDate: string;
  insertDate: string;
}

export type IPayoutRequests = IPagination<IPayoutRequest>;

export interface IPayoutProcessDto {
  status: number;
  approvedAmount: number;
  adminNote: string;
}
